<form class="search-form__form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
  <fieldset #wrapper formGroupName="wrapper" class="search-form__form-wrapper">
    <div class="search-form__form-container">
      <div class="search-form__field-container search-form__field-container--query">
        <label for="query" class="search-form__field-label">Airport ID, Name or City:</label>
        <div class="search-form__field-wrapper">
          <mat-icon *ngIf="searchState === State.Empty || searchState === State.Content"
                    class="search-form__field-icon">search</mat-icon>
          <mat-spinner *ngIf="searchState === State.Loading" [diameter]="16" class="search-form__field-spinner"></mat-spinner>
          <mat-icon *ngIf="searchState === State.Error" class="search-form__field-icon search-form__field-icon--error">warning</mat-icon>
          <input #queryField id="query" type="search" [matAutocomplete]="acTrigger.auto" placeholder="Search"
                 formControlName="query" class="search-form__field search-form__query-field" aria-label="Search"
                 (focus)="onQueryFocus($event)" (blur)="onQueryBlur()" (keypress)="onQueryKeyPress()"
                 autocomplete="off" autocorrect="off">
        </div>
        <div *ngIf="queryCtrl.invalid && (queryCtrl.dirty || queryCtrl.touched)" class="search-form__field-validation">
          <div *ngIf="queryCtrl.errors.minlength" class="search-form__validation-message">
            Please enter at least three characters to perform a search.
          </div>
        </div>
        <div *ngIf="searchErrorMsg" class="search-form__error-msg">
          {{ searchErrorMsg }}
        </div>
      </div>
    </div>
  </fieldset>
</form>

<!-- Regular autocomplete for supported browsers -->
<app-autocomplete-trigger
  #acTrigger
  [query]="queryCtrl.value"
  [queryType]="AutocompleteType.Combined"
  [currentSearchTab]="query.type"
  [searchCtrl]="queryCtrl"
  [(state)]="autocompleteState"
  (itemSelected)="onItemSelected($event)">
</app-autocomplete-trigger>

<!-- Alternative UI for iOS/Android -->
<app-autocomplete-overlay #acOverlay [queryType]="AutocompleteType.Combined" [currentSearchTab]="query.type" (itemSelected)="onItemSelected($event)">
</app-autocomplete-overlay>
